import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux';

// LAYOUT COMPONENTS
import Navbar from '../components/Layout/Navbar'
import FullPageLoader from '../components/Layout/FullPageLoader';
import Empty from '../components/Layout/Empty';

// COMPONENTS
import FilterBar from '../components/totalSalesPeople/FilterBar'
import TotalAgentTable from '../components/totalSalesPeople/TotalAgentTable';
import TotalSalesListing from '../components/totalSalesPeople/TotalSalesListing';
import TotalCommissionListing from '../components/totalSalesPeople/TotalCommissionListing';
import VerticalBarChart from '../components/totalSalesPeople/VerticalBarChart';
import TopAgentCompletedSalesTable from '../components/totalSalesPeople/TopAgentCompletedSalesTable';
import AgentCompletedSalesTable from '../components/totalSalesPeople/AgentCompletedSalesTable';

// DATA
import agentComponent from '../businesses/agent'

// DUMMY
import topAgentCompletedSalesByBranch from '../components/totalSalesPeople/dummy/topAgentCompletedSalesByBranch.json'
import completedSalesCommissionDetailsByAgentUserID from '../components/totalSalesPeople/dummy/completedSalesCommissionDetailsByAgentUserID.json'
import TopGroupCompletedSalesTable from '../components/totalSalesPeople/TopGroupCompletedSalesTable';


const TotalSalesPeoplePage = () => {
  const agentID = useSelector(state => state.viewFromAgentId);
  const tableContainer = useRef(null)

  const [loading, setLoading] = useState(false)
  const [isFetching, setIsFetching] = useState(false)
  const [filterData, setFilterData] = useState(null)
  const [listedBy, setListedBy] = useState('Branch')

  const [salesEntities, setSalesEntities] = useState(null)
  const [peopleEntities, setPeopleEntities] = useState(null)
  const [selectedEntity, setSelectedEntity] = useState(null)
  const [selectedMonthAgents, setSelectedMonthAgents] = useState(null)
  const [selectedAgent, setSelectedAgent] = useState(null)

  const handleFilter = (data) => {
    const filterData = { ...data }

    setListedBy(filterData.LiveListBy)
    setSalesEntities(null)
    setPeopleEntities(null)
    setSelectedEntity(null)
    setSelectedEntity(null)
    setSelectedMonthAgents(null)
    setSelectedAgent(null)

    // RUN THE FILTERING WITH THE filterData
    setFilterData(filterData)
    setIsFetching(!isFetching)
  }

  const selectEntity = (entity) => {
    setSelectedEntity(null)
    setSelectedMonthAgents(null)
    setSelectedAgent(null)

    if (agentID) {
      (async () => {
        setLoading(true)
        filterData.BranchID = entity.BranchID
        filterData.BranchName = entity.BranchName
        const completedSalesCommissionByMonthly = await agentComponent.getCompletedSalesCommissionByMonthly(agentID, filterData)

        if (completedSalesCommissionByMonthly) {
          setSelectedEntity(completedSalesCommissionByMonthly)
          setLoading(false)
        } else {
          setLoading(false)
        }
      })()
    }
  }

  const selectMonth = (month) => {
    setSelectedMonthAgents(null)
    setSelectedAgent(null)

    if (agentID) {
      (async () => {
        setLoading(true)
        filterData.DateYear = month.Year
        filterData.Month = month.Month
        const topRankingCompletedSalesByMonth = await agentComponent.getTopRankingCompletedSalesByMonth(agentID, filterData)

        if (topRankingCompletedSalesByMonth) {
          setSelectedMonthAgents(topRankingCompletedSalesByMonth)
          setLoading(false)
        } else {
          setLoading(false)
        }
      })()
    }
  }

  const selectAgent = (agent) => {
    setSelectedAgent(null)

    const agentID = agent.CommissionPayToUserObjectID

    if (agentID) {
      (async () => {
        setLoading(true)
        filterData.MonthNum = filterData.Month
        const completedSalesDetailsByAgentID = await agentComponent.getCompletedSalesDetailsByAgentID(agentID, filterData)
        if (completedSalesDetailsByAgentID) {
          setSelectedAgent(completedSalesDetailsByAgentID)
          setLoading(false)
        } else {
          setLoading(false)
        }
      })()
    }
  }

  useEffect(() => {
    if (agentID && filterData) {
      (async () => {
        setLoading(true)
        try {
          const [
            completedSalesCommissionByYear,
            newHireSummaryByYear
          ] = await Promise.all([
            agentComponent.getCompletedSalesCommissionByYear(agentID, filterData),
            agentComponent.getNewHireSummaryByYear(agentID, filterData)
          ])
          
          setSalesEntities(completedSalesCommissionByYear)
          setPeopleEntities(newHireSummaryByYear)
          setLoading(false)
        } catch (error) {
          setLoading(false)
        }
      })()
    }
  }, [isFetching])

  useEffect(() => {
    if ( selectedMonthAgents || selectedAgent) {
      setTimeout(() => {
        tableContainer.current.scrollIntoView({
          behavior: 'smooth',
          block: 'end',
        })
      }, 1);
    }
  }, [selectedMonthAgents, selectedAgent])


  return (
    <div className='layout totalsalespeople'>
      <Navbar title='Completed Sales Commission & New Hire' />
      <FilterBar onHandleFilter={ handleFilter } />

      <div className='content-wrapper'>
        <FullPageLoader loading={ loading } />

        <div className='scrollable'>
          <div className='content'>
            {
              salesEntities && peopleEntities ?
              <>
                <div className='flex flex-col md:flex-row h-auto md:h-[220px] gap-3 md:gap-5'>
                  <div className='"w-full md:w-2/3 flex flex-col'>
                    {
                      peopleEntities &&
                      <TotalAgentTable
                        filterData={ filterData }
                        entities={ peopleEntities }
                      />
                    }
                  </div>

                  <div className='w-full md:w-1/3 flex flex-col'>
                    {
                      salesEntities &&
                      <TotalSalesListing
                        filterData={ filterData }
                        entities={ salesEntities }
                        handleClick={ selectEntity }
                      />
                    }
                  </div>
                </div>

                <div className='flex flex-col md:flex-row gap-3 md:gap-5 relative'>
                  <div className='flex md:w-1/3 w-full flex-col'>
                    {
                      selectedEntity &&
                      <TotalCommissionListing
                        filterData={ filterData }
                        entities={ selectedEntity }
                        handleClick={ selectMonth }
                      />
                    }
                  </div>

                  <div className='md:w-2/3 w-full flex flex-col h-full'>
                    {
                      selectedEntity &&
                      <div className='h-full flex flex-col w-full gap-1'>
                        <div className='min-h-[32px] flex items-center'>
                          <p className='font-semibold text-gray-one uppercase text-sm'>{ filterData.DateYear } Sales Commission by Monthly in { filterData.BranchName }</p>
                        </div>

                        <div className='border border-border rounded-[10px] bg-white shadow-md p-4 overflow-hidden flex-1'>
                          <div className='overflow-auto h-full'>
                            <div className='min-w-[100%] md:min-w-0 h-full flex items-center'>
                              <VerticalBarChart
                                chartData={ selectedEntity }
                                monthly={ true }
                                color='#f97315'
                                title='Total Commission (RM)'
                                ratio='2.4'
                                bp='0.17'
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </> :
              <>
                <Empty />
              </>
            }

            {
              selectedMonthAgents &&
              <>
                <div ref={ tableContainer } className='flex w-full flex-col gap-3 md:gap-5 mt-4'>
                  <div className='flex flex-col md:flex-row gap-3 md:gap-5'>
                    <TopGroupCompletedSalesTable
                      selectedEntity={ selectedMonthAgents.commTopGroupCollection }
                      filterData={ filterData }
                    />
                    <TopAgentCompletedSalesTable
                      selectedEntity={ selectedMonthAgents.commTopAgentCollection }
                      filterData={ filterData }
                      handleClick={ selectAgent }
                    />
                  </div>

                  <div className='flex flex-col md:flex-row gap-3 md:gap-5'>
                    {
                      selectedAgent &&
                      <AgentCompletedSalesTable
                        selectedAgent={ selectedAgent }
                        filterData={ filterData }
                      />
                    }
                  </div>
                </div>
              </>
            }
          </div>
        </div>
      </div>
    </div>
  )
}

export default TotalSalesPeoplePage